<div class="content-with-filled-button">
      <main class="field col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 px-0">
        <h2 class="title" id="account_selection">
          <ng-container *ngIf="isFirmlyApproved && hasOrdAndCrp; else default">
            {{copie.title_1}} <strong>{{copie.title_2}}</strong>
          </ng-container>
          <ng-template #default>
            {{copie.title}}
          </ng-template>
        </h2>
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <voxel-form-field class="accountSelectionComponent" [label]="copie.label">
            <vcl-autocomplete [placeholder]="copyService.copies.account_selection.filter_placeholder" (change)="selectOption($event)" required 
            [notFoundTitle]="copyService.copies.marital_status_copies.filter_not_found_title" [notFoundMessage]="copyService.copies.marital_status_copies.filter_not_found_message">
              <vcl-option [id]="option.account_id" *ngFor="let option of options" [selected]="option.product_number === selectedAccountU.account_id" [value]="option">
                {{ option.product_type }} {{ validationHelperService.maskPhone(option.product_number) }}
              </vcl-option>
            </vcl-autocomplete>
          </voxel-form-field>
        </div>
        <div class="card_simple" *ngIf="hasOrdAndCrp">
          <voxel-icon class="icon">informacao_outline</voxel-icon>
          <p>
            {{ copie.title_card_multi }}
          </p>
        </div>
        <div class="checkbox" *ngIf="showCheck">
          <voxel-checkbox [id]="'backDocCheckboxTerms'" [label]="checkboxTerms.label" [checked]="checkboxTerms.checked" name="terms">
          </voxel-checkbox>
        </div>
      </main>
</div>
<app-controls id="maritalStatusBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.account_selection.button" (only_previous)="sendBackButtonEvent()" (next)="next()" [nextDisabled]="validButton"></app-controls>

  